import { useTerminalClasses } from "../theme/context";
import { cx } from "../util/cx";
import type { TerminalController } from "../hooks/useTerminalController";

export interface StatusBarProps {
  controller: TerminalController;
}

export function StatusBar({ controller }: StatusBarProps) {
  const classes = useTerminalClasses();
  const active = controller.providers.find((p) => p.active);

  return (
    <div className={classes.statusBar}>
      <button
        type="button"
        className={classes.statusBarButton}
        onClick={controller.toggle}
        aria-expanded={controller.isOpen}
        aria-label={controller.isOpen ? "Collapse terminal" : "Expand terminal"}
      >
        <span className={cx("rt-chevron", controller.isOpen && "rt-chevron--open")} aria-hidden="true">
          ▲
        </span>
        <span className={classes.statusBarLabel}>{controller.title}</span>
      </button>

      <div className="rt-statusbar-spacer" />

      {controller.busy && (
        <span className="rt-status-busy" aria-live="polite">
          <span className="rt-status-dot" /> working…
        </span>
      )}

      {active && (
        <span className="rt-statusbar-provider" title={`${active.kind} · ${active.model}`}>
          {active.label} · {active.model}
        </span>
      )}
    </div>
  );
}
